module.exports = __webpack_public_path__ + "img/image_part_006.6ea03311.jpg";